export const ROUTES = {
    LOGIN: "/",
    TRANSITION: "/transition",
    TRANSITION_ADMIN: "/transition-admin",
};